import Context from "shared/util/Context";

export const PROMO_DESIGN = {
	"profilephoto": `profile photo - limit ${Context.get("likesCapTotal")}`,
};



// WEBPACK FOOTER //
// ./src/analytics/util/queryParamsMap.js